var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g({}, _vm.$listeners),
    [
      _vm.label
        ? _c("div", { staticClass: "row" }, [
            _c(
              "label",
              {
                staticClass: "col-sm-3 font-weight-bold col-form-label",
                attrs: { for: _vm.id }
              },
              [
                _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
                _vm.required && !_vm.isDisabled
                  ? _c("required-label")
                  : _vm._e(),
                _vm._v(" "),
                _vm.info
                  ? _c("font-awesome-icon", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.info,
                          expression: "info"
                        }
                      ],
                      staticClass: "text-primary ml-1",
                      attrs: { icon: ["fad", "info-circle"] }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isNew
                  ? _c("transition", { attrs: { name: "fade" } }, [
                      _c("span", { staticClass: "badge badge-success" }, [
                        _vm._v("Nieuw")
                      ])
                    ])
                  : _vm.isDirty
                  ? _c("transition", { attrs: { name: "fade" } }, [
                      _c("span", { staticClass: "badge badge-warning" }, [
                        _vm._v("Aangepast")
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-9" },
              [
                _c("multiselect", {
                  staticClass: "country-select",
                  attrs: {
                    options: _vm.countriesOnly,
                    "allow-empty": false,
                    "close-on-select": true,
                    placeholder: _vm.placeholder,
                    "show-labels": false,
                    disabled: _vm.isDisabled == true
                  },
                  on: { input: _vm.updateValue },
                  model: {
                    value: _vm.selectedCountryOnly,
                    callback: function($$v) {
                      _vm.selectedCountryOnly = $$v
                    },
                    expression: "selectedCountryOnly"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.label
        ? _c("multiselect", {
            staticClass: "country-select",
            attrs: {
              options: _vm.countriesOnly,
              "allow-empty": false,
              disabled: _vm.isDisabled == true,
              "close-on-select": true,
              placeholder: _vm.placeholder,
              "show-labels": false
            },
            on: { input: _vm.updateValue },
            model: {
              value: _vm.selectedCountryOnly,
              callback: function($$v) {
                _vm.selectedCountryOnly = $$v
              },
              expression: "selectedCountryOnly"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }